export const POST_TYPES = {
  BUYIN_NEWS: 'buyin-news',
  PUBLIC_NEWS: 'public-news',
  WEBPAGE: 'webpage',
  UPDATES: 'category-vendor-news',
  STRATEGIES: 'category-strategy-2',
};
